const print = [
  {
    path: '/print/mealcost',
    component: () => import('@/components/print/PrintMealcost.vue'),
  },
  {
    path: '/print/expense/etc',
    component: () => import('@/components/print/PrintExpenseEtc.vue'),
  },
  {
    path: '/print/expense/taxi',
    component: () => import('@/components/print/PrintExpenseTaxi.vue'),
  },
  {
    path: '/print/submit',
    component: () => import('@/components/print/PrintSubmit.vue'),
  },
  {
    path: '/print/businesstrip',
    component: () => import('@/components/print/PrintBusinesstrip.vue'),
  },
];

export default print;
